module.exports = __webpack_public_path__ + "0a5fefe1ea763a8d8ac0dfb67f8ab9ef.jpg";